import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'friendlyFilename',
  standalone: true
})
export class FriendlyFilenamePipe implements PipeTransform {

  transform(value: string, ...args: number[]): unknown {
    // Enlève le préfixe numérique jusqu'à ce qu'il rencontre un '_'
    const nameWithoutPrefix = value.replace(/^\d+_/, '');

    // Si le nom de fichier après suppression du préfixe dépasse 20 caractères
    if (nameWithoutPrefix.length > args[0]) {
      // Récupère les 5 premiers caractères, ajoute "..." et les 5 derniers caractères, y compris l'extension
      const firstPart = nameWithoutPrefix.slice(0, args[1]);
      const lastPart = nameWithoutPrefix.slice(-args[2]);
      const extension = value.slice(value.lastIndexOf('.'));

      return `${firstPart}...${lastPart}${extension}`;
    }

    // Si le nom est plus court ou égal à 20 caractères, retourne simplement le nom sans le préfixe
    return nameWithoutPrefix;
  }

}
